import React, { useId } from 'react';
import { AttentionIcon } from '../common/ProjectIcons';

type EarthRangerSiteInputProps = {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
};

const EarthRangerSiteInput = ({
  value,
  onChange,
  error,
}: EarthRangerSiteInputProps) => {
  const suffixId = useId();
  return (
    <div>
      <div className="flex flex-row items-center">
        <input
          id="base_url"
          aria-describedby={suffixId}
          placeholder=""
          className="min-w-0 flex-1 rounded rounded-sm border border-unlisted-neutral-gray-200 p-1.5 px-2 transition-colors duration-300"
          value={value}
          onChange={onChange}
        />
        <span id={suffixId} className="ml-2 shrink-0 text-ui-text-primary-text">
          .pamdas.org
        </span>
      </div>
      {error && (
        <div className="flex flex-row items-center rounded py-1 text-unlisted-orange-600">
          <AttentionIcon />
          <p className="ml-1 mt-0.5">{error}</p>
        </div>
      )}
    </div>
  );
};

export default EarthRangerSiteInput;
